import React from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';

import { VerificationService,
         FormFooterComponent as FormFooter,
} from '@sheerid/jslib';

import { getQueryParamsByName, redirect } from '../../lib/utils/browser';

interface StepSuccessProps {
    verificationService: VerificationService;
}

const StepSuccess = ({ verificationService }: StepSuccessProps) => {
    const viewModel = verificationService.previousViewModel || verificationService.viewModel;
    const defaultTeacherStatus = 'Academic';
    const teacherStatus =  getQueryParamsByName('teacherStatus') || ((viewModel.metadata ? viewModel.metadata.teacherStatus : '')  || defaultTeacherStatus);
    const verificationId = verificationService.verificationResponse.verificationId;
    let redirectDestination: string;

    if (teacherStatus === 'Administrator') {
        redirectDestination = `https://www.esri.com/en-us/industries/education/higher-education/administrative?verificationId=${verificationId}`;
    } else {
        redirectDestination = `https://www.esri.com/en-us/industries/education/higher-education/academic?verificationId=${verificationId}`;
    };

    return (
        <div id="sid-step-success" className="sid-l-container">
            <div className="sid-header sid-l-horz-center sid-l-space-top-md">
                <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                    <FormattedHTMLMessage id="step.success.title" defaultMessage="Success! You've been verified." />
                </div>
            </div>

            <div className="sid-header__subtitle sid-l-horz-center sid-l-two-thirds-width">
                <FormattedHTMLMessage id="step.success.subtitle" defaultMessage={
                    `We have verified your eligibility.`
                } />
            </div>

            <div className="sid-footer sid-l-horz-center sid-l-space-top-lg sid-h-small-text">
                <FormattedMessage id="companyName" defaultMessage="{Company}">
                    {companyName => (
                        <FormattedHTMLMessage id="step.success.verificationOnly"
                            defaultMessage={`
                                SheerID handles verification only.
                                Now that you've been approved, please direct all questions about the
                                promotion terms and/or code use to {companyName} customer service.
                            `}
                            values={{ companyName }}
                        />
                    )}
                </FormattedMessage>
                <div className="sid-submit sid-l-space-top-md">
                    <button
                        onClick={() => redirect(redirectDestination)}
                        className="sid-btn sid-btn--dark"
                    >
                        <FormattedHTMLMessage id="step.success.redirectButtonText" defaultMessage="Use code now" />
                    </button>
                </div>
                <FormFooter verificationService={verificationService}>
                    <div /> {/* suppress default */}
                </FormFooter>
            </div>
        </div>
    );
};

export const StepSuccessComponent = StepSuccess;
